import type { CareplanOrderLine } from "@/domains/careplan/factories/create-careplan-order-model";

type CareplanProductPriceInput = {
  isLoading: boolean;
  line: Pick<CareplanOrderLine, "unitPriceAsString" | "unitListPriceAsString"> | null;
  listPriceAsString: string;
};

export type CareplanProductPrice =
  | { status: "loading" }
  | { status: "list"; amount: string }
  | { status: "careplan"; amount: string; listAmount: string | null };

export const getCareplanProductPrice = ({
  isLoading,
  line,
  listPriceAsString,
}: CareplanProductPriceInput): CareplanProductPrice => {
  if (isLoading) {
    return { status: "loading" };
  }

  if (!line) {
    return { status: "list", amount: listPriceAsString };
  }

  return {
    status: "careplan",
    amount: line.unitPriceAsString,
    listAmount:
      line.unitListPriceAsString === line.unitPriceAsString ? null : line.unitListPriceAsString,
  };
};
